import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radioGroup", "fallback", "currency", "amount", "amountLabel", "czech", "slovak", "description", "mismatch"]
  static values = { listingCurrency: String }

  connect() {
    this.currency = this.selectedCurrency()
    this.render()
    this.radioGroupTarget.hidden = false
    this.fallbackTarget.hidden = true
  }

  change() {
    const currency = this.selectedCurrency()
    if (currency === this.currency) return

    this.amountTarget.value = ""
    this.currency = currency
    this.render()
  }

  selectedCurrency() {
    return this.currencyTargets.find(radio => radio.checked)?.value || "czk"
  }

  render() {
    const eur = this.currency === "eur"
    this.czechTarget.hidden = this.czechTarget.disabled = eur
    this.slovakTarget.hidden = this.slovakTarget.disabled = !eur
    this.amountLabelTarget.textContent = eur ? "Částka v EUR" : "Částka v Kč"
    this.descriptionTarget.textContent = eur
      ? "Platba v EUR na český nebo slovenský IBAN eurového účtu. QR kód PAY by square vytvoříme přímo v MakerBazaru."
      : "Platba v Kč na český účet. QR kód vytvoříme přímo v MakerBazaru."
    this.mismatchTarget.hidden = this.currency === this.listingCurrencyValue
  }
}
